<template>
    <div class="mini_contact_form">
        <div class="mini_form_wrap box_shadow flex">
            <div v-if="value.image" class="image_part">
                <div class="image">
                    <picture v-full-image-path="value.image" />
                </div>
            </div>

            <div class="content_part">
                <div class="content">
                    <div class="form_title">{{ value.title }}</div>

                    <content-builder-contact-form
                        v-model="form"
                        entity="form"
                        :validation="$v"
                        :server-errors="serverErrors"
                        @submit="submitHandler"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { StatusCodes } from 'http-status-codes';
import { required, email, maxLength } from 'vuelidate/lib/validators';

import ContentBuilderContactForm from '@/components/forms/ContentBuilderContact';

export default {
    components: {
        ContentBuilderContactForm
    },

    props: {
        value: {
            type: Object,
            required: true
        },

        article: {
            type: Object,
            required: true
        }
    },

    data() {
        const defaultFormData = {
            fullName: '',
            email: '',
            phone: ''
        };

        return {
            defaultFormData,
            form: cloneDeep(defaultFormData),
            serverErrors: []
        };
    },

    validations: {
        form: {
            fullName: {
                required,
                maxLength: maxLength(200)
            },
            email: {
                required,
                email,
                maxLength: maxLength(320)
            },
            phone: {
                required,
                maxLength: maxLength(15)
            }
        }
    },

    methods: {
        ...mapActions({
            sendContactRequest: 'articles/contact'
        }),

        async submitHandler() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                await this.sendContactRequest({
                    id: this.article.id,
                    ...this.form
                });

                this.$v.$reset();

                this.form = cloneDeep(this.defaultFormData);

                this.$toasted.success(
                    this.$t('contentBuilder.contactForm.messageSent')
                );
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === StatusCodes.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        this.$toasted.global.error({
                            message: this.$t('toasted.recheckForm')
                        });
                    }
                }
            }
        }
    }
};
</script>
